/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React from 'react';
import { Route, Switch } from 'react-router';
import TopNavigationBar from './components/widgets/TopNavigationBar/TopNavigationBar';
import  MessageArea from "./components/widgets/MessageBox/MessageArea";

import HomePageLink from './components/pages/HomePage/HomePageLink';
import BookContainerLink from './components/pages/BookContainer/BookContainerLink';
import NotFound from './components/pages/NotFound/NotFound';
import RedirectComponent from "./components/pages/Redirect/RedirectComponent";

const Routes = () => (<Switch>
    <Route path="/digital-book/:collId" component={BookContainerLink}/>
    <Route path="/redirect/:collId" component={RedirectComponent}/>
    <Route path="*" component={NotFound}/>
</Switch>);

export default Routes;



// WEBPACK FOOTER //
// ./src/routes.js